// Copyright (c) 2015, Alphamonak Solutions

// for translation
melon._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = melon._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = melon._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = melon._;

melon.get_languages = function () {
	if (!melon.languages) {
		melon.languages = [];
		$.each(melon.boot.lang_dict, function (lang, value) {
			melon.languages.push({ label: lang, value: value });
		});
		melon.languages = melon.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return melon.languages;
};
